import { configureStore } from '@reduxjs/toolkit';
import templateSelectedItemReducer from './TemplateSelectedItemSlice';

const templateSelectedItemStore = configureStore({
  reducer: {
    templateSelectedItem: templateSelectedItemReducer
  }
});

export default templateSelectedItemStore;